.container {
  display: flex;
}

.handle {
  cursor: grab;
  display: flex;
  flex: 1;
}
